import React from 'react';
import { ManagerDashboardScreenDesktop } from './ManagerDashboardScreenDesktop';
import { ManagerDashboardScreenMobile } from './ManagerDashboardScreenMobile';

export const ManagerDashboardScreen = () => {
  console.log("ManagerDashboardScreen component rendering");
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    console.log("ManagerDashboardScreen useEffect running");
    const checkScreenSize = () => {
      const mobile = window.innerWidth <= 767;
      console.log("Screen size check:", { width: window.innerWidth, isMobile: mobile });
      setIsMobile(mobile);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  console.log("ManagerDashboardScreen about to render:", isMobile ? "mobile" : "desktop");
  return isMobile ? <ManagerDashboardScreenMobile /> : <ManagerDashboardScreenDesktop />;
};